import { render, staticRenderFns } from "./Increment.vue?vue&type=template&id=a7159a9e"
import script from "./Increment.vue?vue&type=script&lang=js"
export * from "./Increment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports